(function ($) {
  Drupal.behaviors.holidaylandingBlockV1 = {
    attach: function (context) {
      var $selectMenu = $('.js-holiday-dropdown', context);
      var path = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

      path = path.replace(/^/g, '\/');
      $selectMenu.find('option').each(function () {
        var optionValue = $(this).val();

        if (path === optionValue) {
          $(this).attr('selected', true);
        }
      });
      $('.js-tabs__link', context).each(function () {
        var tabPath = $(this).attr('href');

        if (tabPath === path) {
          $(this).addClass('active');
        }
      });
      $selectMenu.change(function (e) {
        e.preventDefault();
        var selectedUrl = $(this).val();

        window.location = selectedUrl;
      });
    }
  };
})(jQuery);
